import { Datepicker } from 'vanillajs-datepicker';

document.addEventListener('DOMContentLoaded', function() {
	const elem = document.querySelector('input#rental_date');
	const datepicker = new Datepicker(elem, {
	  format: {
	        toValue(date, format, locale) {
	            return Datepicker.formatDate(date , 'mm/dd/yyyy');
	        },
	        toDisplay(date, format, locale) {
	            return Datepicker.formatDate(date , 'dd.mm.yyyy');
	        },
	    },
	}); 
});